import { render } from "./FormCheckBoxFieldComponent.vue?vue&type=template&id=73825c76"
import script from "./FormCheckBoxFieldComponent.vue?vue&type=script&lang=js"
export * from "./FormCheckBoxFieldComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__